import { render, staticRenderFns } from "./NotifyPopover.vue?vue&type=template&id=65454eab&scoped=true"
import script from "./NotifyPopover.vue?vue&type=script&lang=js"
export * from "./NotifyPopover.vue?vue&type=script&lang=js"
import style0 from "./NotifyPopover.vue?vue&type=style&index=0&id=65454eab&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65454eab",
  null
  
)

export default component.exports